export const AdminConstants = {
  GET_ALL_USERS: 'GET_ALL_USERS',
  GET_ALL_CATEGORIES: 'GET_ALL_CATEGORIES',
  GET_ALL_MAKES: 'GET_ALL_MAKES',
  GET_ALL_LOCATIONS: 'GET_ALL_LOCATIONS',
  GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
  GET_ALL_GALLERY: 'GET_ALL_GALLERY',
};
